<template>
  <span class="aha-spinner__wrapper">
    <span
      class="aha-spinner"
      :class="`aha-spinner--${variant} aha-spinner--${size}`"
    />
    <span class="mt-4" v-if="text">
      {{ text }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'sm',
    },
    variant: {
      type: String,
      default: 'dark',
    },
  },
}
</script>

<style lang="scss">
.aha-spinner__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.aha-spinner {
  animation: spin 1s linear infinite;
  display: inline-block;
  border-radius: 100%;
}

.aha-spinner--xs {
  height: 1rem;
  width: 1rem;
}

.aha-spinner--sm {
  height: 1.25rem;
  width: 1.25rem;
}

.aha-spinner--md {
  height: 2.5rem;
  width: 2.5rem;
}

.aha-spinner--lg {
  height: 3.75rem;
  width: 3.75rem;
}

.aha-spinner--xl {
  height: 5rem;
  width: 5rem;
}

.aha-spinner--dark {
  border: 2px solid rgba(49, 49, 49, 0.3);
  border-top-color: #313131;
}

.aha-spinner--white {
  border: 2px solid rgba(255, 255 , 255, 0.3);
  border-top-color: #fff;
}

.aha-spinner--tail {
  border-top: 6px solid #4f9af2;
  border-right: 6px solid transparent;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
